import { render, staticRenderFns } from "./DeletePopup.vue?vue&type=template&id=0c0a4cb3&scoped=true"
import script from "./DeletePopup.vue?vue&type=script&lang=js"
export * from "./DeletePopup.vue?vue&type=script&lang=js"
import style0 from "./DeletePopup.vue?vue&type=style&index=0&id=0c0a4cb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0a4cb3",
  null
  
)

export default component.exports